import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import auth from './modules/auth'
import context from './modules/context'
import django from './modules/django'
import abiturient from './modules/abiturient'
import abiturientPassport from './modules/abiturient/passport'
import overlay from './modules/overlay'
import filemanager from './modules/filemanager'
import application from './modules/abiturient/application/application'
import applications from './modules/abiturient/application/applications'
import campaign from './modules/abiturient/application/campaign'
import application_type from './modules/abiturient/application/application_type'
import application_files from './modules/abiturient/application/files'
import application_exams from './modules/abiturient/application/exams'
import operator from './modules/operator'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const logger = createLogger({
  collapsed: true, // автоматически раскрывать залогированные мутации
  logActions: true, // логирование действий
  logMutations: true, // логирование мутаций
  logger: console // реализация API `console`, по умолчанию `console`
});

export default new Vuex.Store({
  modules: {
    context,
    auth,
    django,
    abiturient,
    abiturientPassport,
    overlay,
    filemanager,
    application,
    applications,
    campaign,
    application_type,
    operator,
    application_files,
    application_exams,
  },
  strict: debug,
  plugins: debug ? [logger] : []
})
